import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#3f7fbf", // blue border color
      contrastText: "#ffffff",
    },

    secondary: {
      main: "#3c5f2a", // green buttons
      contrastText: "#ffffff",
    },

    background: {
      default: "#c7d7df", // full page background
      paper: "#cfe0e8",   // container/card background
    },

    text: {
      primary: "#000000",
      secondary: "#2f3e46",
    },
  },

  typography: {
    fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,

    h4: {
      fontWeight: 700,
    },

    h6: {
      fontWeight: 600,
    },

    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },

  shape: {
    borderRadius: 12,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#c7d7df",
        },
        ".MuiPickersTextField-root .MuiOutlinedInput-root, .MuiPickersTextField-root .MuiPickersInputBase-root, .MuiPickersTextField-root .MuiPickersOutlinedInput-root":
          {
            backgroundColor: "#dbe6ec",
          },
        ".MuiPickersTextField-root .MuiOutlinedInput-input, .MuiPickersTextField-root .MuiInputBase-input, .MuiPickersTextField-root .MuiPickersSectionList-root, .MuiPickersTextField-root .MuiPickersSectionList-section, .MuiPickersTextField-root .MuiPickersSectionList-sectionSeparator":
          {
            backgroundColor: "#dbe6ec",
          },
        ".MuiPickersTextField-root .MuiInputAdornment-root, .MuiPickersTextField-root .MuiPickersInputAdornment-root, .MuiPickersTextField-root .MuiInputAdornment-root .MuiButtonBase-root, .MuiPickersTextField-root .MuiPickersInputAdornment-root .MuiButtonBase-root":
          {
            backgroundColor: "#dbe6ec",
          },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#c7d7df",
          color: "#000",
          boxShadow: "none",
          borderBottom: "3px solid #3f7fbf",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#3c5f2a",
          "&:hover": {
            backgroundColor: "#2f4a20",
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#cfe0e8",
          border: "3px solid #3f7fbf",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#dbe6ec",
        },
        notchedOutline: {
          borderColor: "#3f7fbf",
        },
      },
    },

    // Allow scrolling the page behind modal backdrops (dialogs, drawers, popovers, menus).
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDrawer: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
  },
});

export default theme;
